import React from "react";
import {Icon} from "office-ui-fabric-react";

export const DropZone = ({text = 'Drop files here'}) => {
  return (
    <div className="dropzone-active">
        <Icon iconName={'OpenFile'} style={{fontSize: 4 + 'rem', marginTop: 1.5 + 'rem'}}/>
        <p className="first-line">{text}</p>
        <p className="second-line">{"The maximum file size is 10 MB."}</p>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/common/dropZone.js